import { HeaderCallToAction } from './hooks/useHeaderCallToAction/enum';
import { Page } from './telemetry/page';

const External = {
  CAREERS: { path: '/jobs' },
  PRICING: { path: '/pricing' },
  PRIVACY_POLICY: { path: 'https://hover.to/privacy' },
  PRODUCT: { path: '/product' },
  SOCIAL_FACEBOOK: { path: 'https://www.facebook.com/hover3d' },
  SOCIAL_TWITTER: { path: 'https://twitter.com/hover3d' },
  SOCIAL_YOUTUBE: { path: 'https://www.youtube.com/user/Hover3D' },
  START: { path: '/ui/#/properties' },
  TERMS_OF_SERVICE: { path: 'https://hover.to/terms_of_use' },
} as const;

export interface RouteDescriptor {
  path: string;
  page?: Page;
  headerCallToAction?: HeaderCallToAction;
}

type RouteKey =
  | 'DESIGN_STUDIO_SHARE_VIEW'
  | 'DESIGN_STUDIO'
  | 'INTERNAL'
  | 'INTERNAL_LOGOUT'
  | 'INTERNAL_PROFILE'
  | 'LOGIN'
  | 'LOGIN_FORGOT_PASSWORD'
  | 'LOGIN_FORGOT_PASSWORD_SUCCESS'
  | 'LOGIN_SSO'
  | 'LOGIN_SSO_FAILURE'
  | 'LOGIN_SSO_SUCCESS'
  | 'MOBILE'
  | 'NOT_FOUND'
  | 'ROOT'
  | 'SIGN_UP'
  | 'SIGN_UP_HOMEOWNER'
  | 'SIGN_UP_HOMEOWNER_DOWNLOAD'
  | 'SIGN_UP_HOMEOWNER_DOWNLOAD_SUCCESS'
  | 'SIGN_UP_PROFESSIONAL'
  | 'SIGN_UP_PROFESSIONAL_ORGANIZATION'
  | 'SIGN_UP_PROFESSIONAL_SSO';

const Route: { [key in RouteKey]: RouteDescriptor } = {
  DESIGN_STUDIO_SHARE_VIEW: {
    path: '/design-studio/shared/:id',
    page: Page.DESIGN_STUDIO_SHARE_VIEW,
  },
  DESIGN_STUDIO: { path: '/design-studio/:id', page: Page.DESIGN_STUDIO },
  INTERNAL: { path: '/i' },
  INTERNAL_PROFILE: { path: '/i/profile' },
  INTERNAL_LOGOUT: { path: '/i/logout' },
  LOGIN: {
    headerCallToAction: HeaderCallToAction.SIGN_UP,
    path: '/login',
    page: Page.LOGIN__INPUT,
  },
  LOGIN_FORGOT_PASSWORD: {
    path: '/login/forgot-password',
    page: Page.FORGOT_PASSWORD__INPUT,
  },
  LOGIN_FORGOT_PASSWORD_SUCCESS: {
    path: '/login/forgot-password/success',
    page: Page.PASSWORD_EMAIL_SENT,
  },
  LOGIN_SSO: {
    headerCallToAction: HeaderCallToAction.SIGN_UP,
    path: '/login/sso',
    page: Page.SSO_LOGIN__INPUT,
  },
  LOGIN_SSO_FAILURE: {
    path: '/login/sso/failure',
    page: Page.SSO_LOGIN_FAILURE,
  },
  LOGIN_SSO_SUCCESS: {
    path: '/login/sso/success',
    page: Page.SSO_LOGIN_SUCCESS,
  },
  MOBILE: {
    headerCallToAction: HeaderCallToAction.NONE,
    path: '/signup/mobile',
  },
  NOT_FOUND: { path: '/404' },
  ROOT: { path: '/' },
  SIGN_UP: { path: '/signup', page: Page.SIGNUP__FORK },
  SIGN_UP_HOMEOWNER: {
    path: '/signup/homeowner',
    page: Page.HOMEOWNER_ACCOUNT__INPUT,
  },
  SIGN_UP_HOMEOWNER_DOWNLOAD: {
    path: '/signup/homeowner/download',
    page: Page.HOMEOWNER_DOWNLOAD__INPUT,
  },
  SIGN_UP_HOMEOWNER_DOWNLOAD_SUCCESS: {
    path: '/signup/homeowner/download/success',
    page: Page.HOMEOWNER_DOWNLOAD_SENT,
  },
  SIGN_UP_PROFESSIONAL: {
    path: '/signup/professional',
    page: Page.PROFESSIONAL_ACCOUNT__INPUT,
  },
  SIGN_UP_PROFESSIONAL_SSO: {
    path: '/signup/professional/sso',
    page: Page.SSO_EMAIL__INPUT,
  },
  SIGN_UP_PROFESSIONAL_ORGANIZATION: {
    path: '/signup/professional/organization',
    page: Page.COMPLETE_PROFILE__INPUT,
  },
} as const;

export { External, Route };
